import { Fragment } from "react";
import "./HomeStatisticBarSkeleton.css";

/**
 * HomeStatisticBarSkeleton
 * 
 * A presentational React component that renders a skeleton loader version of the HomeStatisticBar.
 * It serves as a placeholder UI while statistics data is being fetched or is unavailable.
 * 
 * Styling relies on utility classes (e.g., `skeleton-placeholder`, `width25`, `height2`) 
 * and custom CSS for shimmer effects.
 * 
 * Usage:
 * ```tsx
 * {isLoading && <HomeStatisticBarSkeleton />}
 * ```
 * 
 * @component
 * @returns {JSX.Element} A skeleton loader for the home statistics bar section.
 */
const HomeStatisticBarSkeleton = () => {
    return (
        <Fragment>
            <div className="home-statistic-bar-skeleton__heading">
                <div className="skeleton-placeholder width25 height3"></div>
            </div>
            <div className="home-statistic-bar-skeleton__chart-label">
                <div className="skeleton-placeholder width10"></div>
            </div>
            <div className="home-statistic-bar-skeleton__chart">
                <div className="skeleton-placeholder chart-label"></div>
            </div>
            <div className="fullwidth space-around">
                {[...Array(3)].map((_, i) => {
                    return (
                        <div key={i} className="flex mr-4 center-vertical">
                            <div className="chart-legend-color skeleton-placeholder mr-2"></div>
                            <div className="skeleton-placeholder width10"></div>
                        </div>
                    );
                })}
            </div>
        </Fragment>
    );
}

export default HomeStatisticBarSkeleton;
